import { MapPin, Star, Heart, UserPlus, Check, AlertTriangle, CircleCheck, Eye } from "lucide-react";
import { money } from "@/lib/api";

const AVAIL = {
  available: { cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/25", icon: CircleCheck, label: "Disponível" },
  conflict: { cls: "text-amber-400 bg-amber-500/10 border-amber-500/25", icon: AlertTriangle, label: "Conflito de agenda" },
  unavailable: { cls: "text-red-400 bg-red-500/10 border-red-500/25", icon: AlertTriangle, label: "Indisponível" },
};

function compatTone(p) {
  if (p >= 80) return "text-emerald-400 border-emerald-500/40";
  if (p >= 60) return "text-primary border-primary/40";
  if (p >= 40) return "text-amber-400 border-amber-500/40";
  return "text-muted-foreground border-border";
}

export default function MusicianMatchCard({ m, selected, onToggleSelect, onInvite, onToggleFav, onView, inviteLabel = "Convidar", compact = false }) {
  const av = AVAIL[m.availability] || AVAIL.unavailable;
  const AvIcon = av.icon;
  return (
    <div data-testid={`musician-card-${m.user_id}`}
      className={`rounded-2xl border p-4 transition-all ${selected ? "border-primary bg-primary/[0.07] ring-1 ring-primary/40" : "border-border bg-card hover:border-primary/30"}`}>
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-full bg-[#1C1C24] overflow-hidden flex items-center justify-center text-base font-bold shrink-0">
          {m.photo ? <img src={m.photo} alt="" className="h-full w-full object-cover" /> : (m.stage_name?.[0] || "?")}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h4 className="font-semibold truncate">{m.stage_name || "Músico"}</h4>
            {typeof m.compatibility === "number" && (
              <span data-testid={`compat-${m.user_id}`} className={`text-[11px] font-bold px-2 py-0.5 rounded-full border shrink-0 ${compatTone(m.compatibility)}`}>{m.compatibility}% match</span>
            )}
          </div>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-xs text-muted-foreground">
            {m.instrument && <span className="text-foreground/80 font-medium">{m.instrument}</span>}
            {m.distance_km != null && <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{m.distance_km} km</span>}
            {m.rating?.count > 0 && <span className="flex items-center gap-1"><Star className="h-3 w-3 text-amber-400 fill-amber-400" />{m.rating.avg} ({m.rating.count})</span>}
            {typeof m.score === "number" && <span>Score {m.score}</span>}
            {m.cache != null && m.cache > 0 && <span className="text-accent font-mono">{money(m.cache)}</span>}
          </div>
          <div className={`inline-flex items-center gap-1 mt-2 text-[11px] px-2 py-0.5 rounded-full border ${av.cls}`}>
            <AvIcon className="h-3 w-3" />{av.label}
          </div>
          {m.history_with_creator > 0 && <span className="ml-2 text-[11px] text-muted-foreground">· {m.history_with_creator}x com você</span>}
        </div>
        {onToggleFav && (
          <button data-testid={`fav-toggle-${m.user_id}`} onClick={() => onToggleFav(m)} title={m.is_favorite ? "Remover da equipe" : "Salvar na equipe"}
            className={`shrink-0 h-9 w-9 flex items-center justify-center rounded-lg border transition-colors ${m.is_favorite ? "border-red-500/40 bg-red-500/10 text-red-400" : "border-border text-muted-foreground hover:text-red-400 hover:border-red-500/30"}`}>
            <Heart className={`h-4 w-4 ${m.is_favorite ? "fill-red-400" : ""}`} />
          </button>
        )}
      </div>
      {!compact && (onInvite || onToggleSelect || onView) && (
        <div className="flex gap-2 mt-3">
          {onToggleSelect && (
            <button data-testid={`select-${m.user_id}`} onClick={() => onToggleSelect(m)}
              className={`flex-1 h-9 rounded-lg text-sm font-semibold flex items-center justify-center gap-1.5 transition-colors ${selected ? "bg-primary text-primary-foreground" : "bg-primary/10 text-primary border border-primary/30 hover:bg-primary/20"}`}>
              {selected ? <><Check className="h-4 w-4" />Selecionado</> : <><UserPlus className="h-4 w-4" />Selecionar</>}
            </button>
          )}
          {onInvite && (
            <button data-testid={`invite-${m.user_id}`} onClick={() => onInvite(m)}
              className="flex-1 h-9 rounded-lg text-sm font-semibold flex items-center justify-center gap-1.5 bg-primary/10 text-primary border border-primary/30 hover:bg-primary/20 transition-colors">
              <UserPlus className="h-4 w-4" />{inviteLabel}
            </button>
          )}
          {onView && (
            <button data-testid={`view-${m.user_id}`} onClick={() => onView(m)} className="h-9 px-3 rounded-lg text-sm text-muted-foreground border border-border hover:text-foreground transition-colors flex items-center gap-1.5"><Eye className="h-4 w-4" />Perfil</button>
          )}
        </div>
      )}
    </div>
  );
}
